<template>
  <div class="page-root">
    <h1><span class="font-weight-bold">펫 랭킹</span></h1>
    <p class="text-caption grey--text mb-4">레벨이 가장 높은 펫을 보여줘요 🏆</p>

    <div v-if="loading" class="text-caption grey--text">불러오는 중…</div>
    <div v-else-if="!rows.length" class="text-caption grey--text">아직 랭킹에 오른 펫이 없어요.</div>

    <div v-else class="rank-list">
      <div v-for="(row, i) in rows" :key="i" class="rank-row" :class="{ top: i < 3 }">
        <!-- 순위 -->
        <div class="rank-row__no">{{ medal(i) }}</div>

        <!-- 펫 -->
        <v-avatar size="44" class="rank-row__pet-img" tile>
          <v-img
            v-if="!row._petFailed"
            :src="petThumb(row)"
            :alt="row.petName"
            @error="$set(row, '_petFailed', true)"
          />
          <span v-else class="rank-row__fallback">🐾</span>
        </v-avatar>
        <div class="rank-row__pet">
          <div class="rank-row__pet-name">{{ row.petName }}</div>
          <div class="rank-row__level">Lv.{{ row.level }}</div>
        </div>

        <v-spacer />

        <!-- 주인 (우측): 프로필 사진 + 이름 -->
        <div class="rank-row__owner">
          <v-avatar size="28" class="rank-row__owner-img">
            <v-img
              v-if="row.ownerImageUrl && !row._ownerFailed"
              :src="row.ownerImageUrl"
              :alt="row.ownerName"
              @error="$set(row, '_ownerFailed', true)"
            />
            <span v-else class="rank-row__owner-initial">{{ (row.ownerName || "?").charAt(0) }}</span>
          </v-avatar>
          <div class="rank-row__owner-text">
            <span class="rank-row__owner-label">주인</span>
            <span class="rank-row__owner-name">{{ row.ownerName }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SupabaseApi from "@/api/SupabaseApi";

export default {
  name: "RankingPage",
  data() {
    return {
      loading: true,
      rows: [],
    };
  },
  async mounted() {
    try {
      this.rows = await SupabaseApi.PetRanking.fetch(50);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    medal(i) {
      return ["🥇", "🥈", "🥉"][i] || `${i + 1}`;
    },
    // model_url → 썸네일 modelIndex ("models/v5/fox_v5+…glb" → "fox")
    petThumb(row) {
      const url = row.modelUrl || "";
      const base = (url.split("/").pop() || "").replace(/\.(glb|gltf)$/i, "");
      const modelIndex = base.split("+")[0].replace(/_v\d+$/i, "");
      return `/trial/thumbnails/${modelIndex}_thumbnail.png`;
    },
  },
};
</script>

<style scoped>
.page-root {
  padding: 24px 28px;
}
.rank-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 640px;
}
.rank-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #eceaf3;
}
.rank-row.top {
  background: linear-gradient(135deg, #fff8e8, #fff2d6);
  border-color: #f1d999;
}
.rank-row__no {
  width: 32px;
  text-align: center;
  font-size: 18px;
  font-weight: 800;
  color: #6a4a14;
}
.rank-row__pet-img {
  border-radius: 8px;
  background: #f4f5fa;
}
.rank-row__pet-name {
  font-size: 14px;
  font-weight: 700;
  color: #2a2540;
}
.rank-row__level {
  font-size: 12px;
  font-weight: 700;
  color: #8e6fd6;
}
.rank-row__fallback {
  font-size: 22px;
}
.rank-row__owner {
  display: flex;
  align-items: center;
  gap: 8px;
}
.rank-row__owner-img {
  background: #ece9f5;
}
.rank-row__owner-initial {
  font-size: 13px;
  font-weight: 700;
  color: #8e6fd6;
}
.rank-row__owner-text {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.rank-row__owner-label {
  font-size: 11px;
  color: #a8a4b8;
}
.rank-row__owner-name {
  font-size: 13px;
  font-weight: 600;
  color: #57545d;
}
</style>
